// removed by extract-text-webpack-plugin
module.exports = {"root":"PresentationNode--root--2d","count":"PresentationNode--count--33","accessory":"PresentationNode--accessory--3X","icon":"PresentationNode--icon--uI","main":"PresentationNode--main--31","name":"PresentationNode--name--2w","progress":"PresentationNode--progress--rJ","progressTrack":"PresentationNode--progressTrack--jc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PresentationNode/styles.styl
// module id = 887
// module chunks = 0